const isDateGuard = (date: unknown): date is Date => Object.prototype.toString.call(date) === '[object Date]';
const isValidJSDate = (date: unknown): date is Date => isDateGuard(date) && !Number.isNaN(date.getTime());

export default isValidJSDate;
